module.exports = __webpack_public_path__ + "static/media/FCP01@xs.b83d6196.jpg";